//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config'
// import axios from 'axios'
// import qs from 'qs' // 引入qs
import { operateCreditlist } from '@/api/user.js'
import { getMd5Openid } from '@/api/youzheng.js'
export default {
  data () {
    return {
      owner_type: config.owner_type,
      text: '',
      mobile: this.$store.state.user.personObj.mobile
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    this.addIntegral()
    this.link()
  },
  created () { },
  methods: {
    // 参加活动加积分
    addIntegral (credit) {
      operateCreditlist({
        accountid: this.accountid,
        rulecode: 'ygx_rule',
        credit: 1,
        owner_type: this.owner_type,
        relationtype: 2,
        relationid: 1,
        terminaltype: 2
      }).then(res => { })
    },
    link () {
      var _this = this
      getMd5Openid({
        userid: this.userid
      }).then(res => {
        _this.text = res.returnValue.md5
        // axios.post('https://website.shwread.cn/lqsw_website/audiobookRedirect.do', qs.stringify({
        //   epId: 10000226,
        //   token: res.returnValue.md5
        // })).then(function (response) {
        // })
      })
    }
  }
}
